import { cardsDataTypes } from '@/types'

export const cardsData: cardsDataTypes[][] = [
  [
    {
      img: 'https://source.unsplash.com/random/500x400',
      title: 'Gallery',
      text: 'Magni inventore repellat dignissimos eveniet dolore ex sit illo adipisci accusamus quos.',
      link: '/gallery',
    },
    {
      img: 'https://source.unsplash.com/random/400x400',
      title: 'My account',
      text: 'Magni inventore repellat dignissimos eveniet dolore ex sit illo adipisci accusamus quos.',
      link: '/myaccount',
    }
  ],
  [
    {
      img: 'https://source.unsplash.com/random/600x500',
      title: 'Our Mission',
      text: 'Magni inventore repellat dignissimos eveniet dolore ex sit illo adipisci accusamus quos.',
      link: '/about',
    },
    {
      img: 'https://source.unsplash.com/random/400x300',
      title: 'Premium zone',
      text: 'Magni inventore repellat dignissimos eveniet dolore ex sit illo adipisci accusamus quos.',
      link: '/premium',
    }
  ]
]
